import React from "react";

import Table from "../Table";

import { superAdminSelectors, useSelector } from "../../../state";
import {
  SUPER_ADMIN_FACILITIES_TABLE_COLUMNS,
  SUPER_ADMIN_FACILITIES_TABLE_COLUMN_EXTENSIONS,
} from "../../../constants";
import SuperAdminPages from "../../../pages/super-admin";

// TODO add types and interfaces
const FacilitiesTable = ({ ...props }) => {
  const facilities = useSelector(superAdminSelectors.facilities);
  const searchQuery = useSelector(superAdminSelectors.searchQuery);

  return (
    <Table
      {...props}
      rows={facilities}
      columns={SUPER_ADMIN_FACILITIES_TABLE_COLUMNS}
      searchValue={searchQuery}
      tableColumnExtensions={SUPER_ADMIN_FACILITIES_TABLE_COLUMN_EXTENSIONS}
      rowBaseUrl={SuperAdminPages.facilities.path}
      exportEnabled={true}
      exportedFileName="Facilities"
    />
  );
};

export default React.memo(FacilitiesTable);
